import { Box, Typography } from '@mui/material';

import useUserDetails from '@/hooks/useUserDetails';

const PREMIUM_MESSAGE = {
  title: 'This is a Premium feature.',
  subtitle: 'Upgrade to GX Go Premium to enable charts and unlock advanced functionality.'
};

const BasicUserMessage = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
    <Typography sx={{ fontWeight: 600, fontSize: '24px' }}>{PREMIUM_MESSAGE.title}</Typography>
    <Typography sx={{ fontWeight: 600, fontSize: '24px' }}>{PREMIUM_MESSAGE.subtitle}</Typography>
  </Box>
);

const BlurBackdrop = () => {
  const { isUserPremium, isUserExpired } = useUserDetails();

  if (isUserPremium && !isUserExpired) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backdropFilter: 'blur(4px)',
          zIndex: 1400
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '50%',
          textAlign: 'center',
          transform: 'translateX(-50%)',
          zIndex: 1401,
          width: '100%'
        }}
      >
        <BasicUserMessage />
      </Box>
    </>
  );
};

export default BlurBackdrop;
